import macbook from "@/assets/landing/macbook.webp";

/**
 * The macbook asset ships with the "NODRIC | PANEL" wordmark above and the
 * caption below the device baked in; both bands are cropped away so the real
 * DOM text is the only copy on screen.
 */
export default function MacbookFrame({
  alt = "",
  className = "",
  imageClassName = "",
}: {
  alt?: string;
  className?: string;
  imageClassName?: string;
}) {
  return (
    <div className={`overflow-hidden ${className}`}>
      <img
        src={macbook}
        alt={alt}
        className={`w-full ${imageClassName}`}
        style={{ marginTop: "-10.2%", marginBottom: "-10.6%" }}
      />
    </div>
  );
}
